import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { req } from '../services/api';

export default function Sidebar({ username, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [stats, setStats] = useState({});

  useEffect(() => {
    let active = true;

    const loadSidebarStats = async () => {
      try {
        const data = await req('GET', '/stats');
        if (active && data) setStats(data);
      } catch (error) {
        console.error('Sidebar stats load failed:', error);
      }
    };

    loadSidebarStats();

    return () => {
      active = false;
    };
  }, [location.pathname]);

  const driverBadge =
    (stats.pendingIndependentDrivers || 0) +
    (stats.pendingDriverDocs || 0);

  const fleetBadge =
    (stats.pendingFleets || 0) +
    (stats.pendingFleetDocs || 0);

  const fleetDriverBadge =
    (stats.pendingFleetDrivers || 0) +
    (stats.pendingFleetDriverDocs || 0);

  const payoutBadge =
    (stats.pendingDriverPayouts || 0) +
    (stats.pendingFleetPayouts || 0);

  const sections = [
    {
      label: null,
      items: [
        { path: '/', label: 'Přehled', icon: '▦' }
      ]
    },
    {
      label: 'Uživatelé',
      items: [
        { path: '/customers', label: 'Zákazníci', icon: '●' },
        { path: '/drivers', label: 'Řidiči', icon: '◆', badge: driverBadge },
        { path: '/fleets', label: 'Flotily', icon: '■', badge: fleetBadge },
        { path: '/fleet-drivers', label: 'Řidiči flotil', icon: '◇', badge: fleetDriverBadge }
      ]
    },
    {
      label: 'Provoz',
      items: [
        { path: '/rides', label: 'Jízdy', icon: '→', badge: stats.activeRides || 0 },
        { path: '/vehicles', label: 'Vozidla', icon: '▰', badge: stats.pendingVehicles || 0 }
      ]
    },
    {
      label: 'Finance',
      items: [
        { path: '/payouts', label: 'Výplaty', icon: '€', badge: payoutBadge },
        { path: '/referrals', label: 'Referral program', icon: '%' }
      ]
    },
    {
      label: 'Systém',
      items: [
        { path: '/settings', label: 'Nastavení', icon: '⚙' }
      ]
    }
  ];

  const handleNav = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  return (
    <>
      <div className="mobile-header">
        <button
          className="hamburger"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Menu"
        >
          ☰
        </button>
        <div className="sidebar-logo">
          EURO<span>.taxi</span>
        </div>
      </div>

      {sidebarOpen && (
        <div
          className="overlay active"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={'sidebar ' + (sidebarOpen ? 'open' : '')}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            EURO<span>.taxi</span>
          </div>
          <div className="sidebar-admin-label">ADMINISTRACE</div>
          <div className="sidebar-user">{username}</div>
        </div>

        <nav className="nav">
          {sections.map((section, sectionIndex) => (
            <div className="nav-section" key={section.label || sectionIndex}>
              {section.label && (
                <div className="nav-section-label">{section.label}</div>
              )}

              {section.items.map(item => (
                <button
                  key={item.path}
                  type="button"
                  className={
                    'nav-item ' +
                    (location.pathname === item.path ? 'active' : '')
                  }
                  onClick={() => handleNav(item.path)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>

                  {(item.badge || 0) > 0 && (
                    <span className="nav-badge">{item.badge}</span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={onLogout}>
            Odhlásit se
          </button>
        </div>
      </aside>
    </>
  );
}
